import { GanttColumnViewModel } from './ganttColumnViewModel';

export class LocaliseGanttViewModel {
  ganttColumns: GanttColumnViewModel[];
  accountId: number;
}
